import { React, useState, useEffect } from "react";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../api_Routes";
import { useSnackbar } from "notistack";
import Details from "./Details/GeneralDetails";
import EditPanelComponent from "./Details/EditPanelComponent";
import MainLoader from "../../../../components/common/main-loader";
import NoPanelWrapper from "../no-panel";
import { useNavigate, useParams } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {useCenteredSnackbar} from "../../../../tools/useCenteredSnackbar";

const EditPanel = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  //todo : remove {} from init panel
  const [Panel, setPanel] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar,closeSnackbar } = useSnackbar();
  const { showCenteredPopup } = useCenteredSnackbar();
  const [isPanelsLoading, setIsPanelsLoading] = useState(false);
  const baseApi = api_Routes.Providers.getPanelById(id);


  const action = key => (
      <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={() => closeSnackbar(key)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
  );

  const get_Panels = async () => {
    setIsPanelsLoading(true);
    let url = `${baseApi}`;
    const { response, message } = await Helper.Get({
      url: url,
      hasToken: true,
    });
    if (response && response.success) {
      setPanel({
        id: response.data.panel_details.id,
        name: response.data.panel_details.name,
        email: response.data.panel_details.email,
        logo: response.data.panel_details.logo,
        customLogo: response.data.panel_details.customLogo,
        description: response.data.panel_details.description,
        trust: response.data.panel_details.trust,
        screenshot_urls: response.data.panel_details.screenshot_urls,
        photos: response.data.panel_details.photos,
        url: response.data.panel_details.url,
        smmpanel_whatsapp: response.data.panel_details.whatsapp,
        rate: response.data.rate.avg,
        telegram: response.data.panel_details.telegram,
        twitter: response.data.panel_details.twitter,
        instagram: response.data.panel_details.instagram,
        smmpanel_fb: response.data.panel_details.smmpanel_fb,
        smmpanel_skybe: response.data.panel_details.smmpanel_skybe,
        tel1: response.data.panel_details.tel1,
        tel2: response.data.panel_details.tel2,
        tel3: response.data.panel_details.tel3,
        domain_registered: response.data.panel_details.domain_registered,
        payment_method: response.data.payment_method,
        count_review: response.data.count_review,
        country_code: response.data.panel_details.country_code,
        country_name: response.data.panel_details.country_name,
      });
    } else {
      console.log("API Response:", response, message);
      showCenteredPopup(message,
          { variant: "error",
            persist: true });
      // enqueueSnackbar(message, { variant: "error",
      //   persist: true,
      //   action, });
    }
    setIsPanelsLoading(false);
    console.log("API Response:", response, message);
  };

  const onSave = async (formData) => {
    setIsLoading(true);

    // Ensure the Panel has an `id`
    if (!Panel.id) {
      showCenteredPopup("Panel ID is missing.",
          { variant: "error",
            persist: true });
      // enqueueSnackbar("Panel ID is missing.", { variant: "error",
      //   persist: true,
      //   action, });
      setIsLoading(false);
      return;
    }

    const url = api_Routes.Providers.edit(Panel.id);
    const updatedFormData = { ...formData };

    if (!Array.isArray(formData.screenshot_urls)) {
      formData.screenshot_urls = [];
    }
    // Remove logo if it hasn't changed
    if (
      !(updatedFormData.logo instanceof File) // Still the same as backend
    ) {
      delete updatedFormData.logo;
    }
    // Make the API call
    const result = await Helper.Post({
      url: url,
      data: formData,
      hasToken: true,
    });

    const { response, message } = result || {};

    if (response && response.success) {
      showCenteredPopup("Panel updated successfully.",
          { variant: "success",
            persist: true });
      // enqueueSnackbar("Panel updated successfully.", { variant: "success",
      //   persist: true,
      //   action, });
      navigate("/dashboard/mypanels"); // Navigate back to the panel list
    } else {
      showCenteredPopup(message || "Failed to update panel.",
          { variant: "error",
            persist: true });
      // enqueueSnackbar(message || "Failed to update panel.", {
      //   variant: "error",
      //   persist: true,
      //   action,
      // });
    }

    setIsLoading(false);
  };

  const onCancel = () => {
    navigate("/dashboard/mypanels");
  };

  useEffect(() => {
    get_Panels();
  }, []);

  return isPanelsLoading ? (
    <MainLoader isFull={true} />
  ) : Panel ? (
    <Details
      Panel={Panel}
      onSave={onSave}
      onCancel={onCancel}
      isLoading={isLoading}
    />
  ) : (
    <NoPanelWrapper />
  );
};
export default EditPanel;
